import { Component, Input, Output,EventEmitter } from '@angular/core';

@Component({
    selector: 'order-pay',
    templateUrl: 'order-pay.component.html',
    styleUrls: ['order-pay.component.scss']
})
export class OrderPayComponent {

    @Input()
    createdAt: string;
    readyIn: number;
    delay = 15

    @Output()
    OnPayEvent:EventEmitter<boolean>=new EventEmitter<boolean>(); 

    @Input() loading=false;
    
    ngOnInit() {
        this.readyIn = this.getReadyIn(this.createdAt);
        setInterval(
            () => {
                this.readyIn = this.getReadyIn(this.createdAt);
            }, 60000
        )
    }

    getDate(fullDate) {
        let arr = fullDate.split(/\D+/);
        let date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
        return +date;
    }

    getReadyIn(d) {
        let date = +new Date();
        let dateCmd =  this.getDate(d);
        var tmp = Math.floor((date - dateCmd) / 60000);
        return (tmp < this.delay)?this.delay-tmp:0;
    }

    pay(){
        this.OnPayEvent.next(true)
    }
}
